// extracted by mini-css-extract-plugin
module.exports = {"confirmModal":"styles_confirmModal__1LhDN","overlayConfirmModal":"styles_overlayConfirmModal__32FR7","buttonContainer":"styles_buttonContainer__2pGQg"};